import { useMutation } from '@tanstack/react-query';

import { connectGoCardless } from '../api/connect';
import { goCardlessMutationKeys } from '../data';

export const useConnectGoCardless = () => {
  const mutation = useMutation({
    mutationKey: goCardlessMutationKeys.connect,
    mutationFn: connectGoCardless,
  });

  return mutation;
};
